import React from "react";
import { TR } from "../styledEdit";
import CellNumber from "./CellNumber";
import Cell from "./Cell";

const Row = ({
  rowIdx,
  row,
  cols,
  setSettingsDraft,
  addRow,
  removeRow,
  onChange,
}) => {
  const { cells } = row;

  return (
    <TR>
      <CellNumber
        rowIdx={rowIdx}
        setSettingsDraft={setSettingsDraft}
        addRow={addRow}
        removeRow={removeRow}
      />
      {cells.map((cell, cellIdx) => {
        return (
          <Cell
            key={cell.id}
            rowIdx={rowIdx}
            cellIdx={cellIdx}
            cell={cell}
            cols={cols}
            onChange={onChange}
            setSettingsDraft={setSettingsDraft}
          />
        );
      })}
    </TR>
  );
};

export default Row;
